import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';

const WelcomeCard = () => {
  return (
    <Paper
      elevation={6}
      sx={{
        padding: '40px',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
        marginBottom: '50px',
        backgroundColor: (theme) => theme.palette.background.paper,
        color: (theme) => theme.palette.text.primary,
      }}
    >
      <img src="/mascot.png" alt="Snapperish Mascot" style={{ height: '120px', marginBottom: '20px' }} />
      <Typography variant="h4" gutterBottom>
        Welcome to Snapperish!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Join exciting photo contests, manage submissions, and vote for your favorites.
      </Typography>
      {process.env.REACT_APP_COMING_SOON === 'true' ? (
        <Typography variant="h5" sx={{ marginTop: '20px', fontStyle: 'italic' }}>
          Coming Soon!
        </Typography>
      ) : (
        <div style={{ marginTop: '20px' }}>
          <Link to="/myclubisonsnapperish" style={{ marginRight: '20px', textDecoration: 'none' }}>
            <button style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>My club is on Snapperish!</button>
          </Link>
          <Link to="/signup" style={{ marginRight: '20px', textDecoration: 'none' }}>
            <button style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>Sign Up</button>
          </Link>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <button style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>Log In</button>
          </Link>
        </div>
      )}
    </Paper>
  );
};

export default WelcomeCard;